import { useState } from 'react';
import { fmt, fmtKc, num } from '../../lib/formatters';

// Sdílené třídy pro číselné buňky v tabulkách (dřív konstanta CELL v každé vrstvě).
export const CELL = 'w-full bg-transparent border-0 outline-none text-right tabular-nums px-2 py-2 text-[14px] rounded-md ' +
    'focus:ring-1 focus:ring-blue-500/60 focus:bg-blue-500/10 ' +
    '[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none';
export const CELL_SM = 'w-full bg-transparent border-0 outline-none text-right tabular-nums px-2 py-1.5 text-[13px] rounded ' +
    'focus:ring-1 focus:ring-blue-500/60 focus:bg-blue-500/10 ' +
    '[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none';

// Číselná buňka: formátované číslo v klidu (1 234 567 / … Kč), holé číslo při editaci.
// Sjednocuje 4 dřívější kopie (Příjmy, Energie, Ostatní NumCell + Personal MonthCell).
//
// Props:
//   kc         – v klidu zobrazit se suffixem „ Kč" (Příjmy, Energie)
//   blankEmpty – prázdná hodnota v klidu = prázdno místo „—" (Ostatní)
//   sm         – menší varianta (py-1.5 / 13px) — jinak md (py-2 / 14px)
//   bold, title, placeholder, color – dle volajícího
export function NumCell({ value, onChange, color = 'var(--text-primary)', bold, title, placeholder, kc = false, blankEmpty = false, sm = false }) {
    const [focused, setFocused] = useState(false);
    const empty = value === '' || value == null;
    const rest = blankEmpty && empty ? '' : (kc ? fmtKc(value) : fmt(value));
    const display = focused ? (empty ? '' : String(Math.round(num(value)))) : rest;
    return (
        <input type="text" inputMode="numeric" value={display} title={title} placeholder={placeholder}
            onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
            onChange={e => onChange(e.target.value.replace(/[^\d.-]/g, ''))}
            className={(sm ? CELL_SM : CELL) + (bold ? ' font-semibold' : '')} style={{ color }} />
    );
}

export default NumCell;
